// import React, { useState } from "react";
// import Table from "../../../../core/pagination/datatable";
// import { Link } from "react-router-dom";
// import { Button, Input } from "antd";

// const RfidAssign = () => {
//   //   const [loading, setLoading] = useState(true);
//   //   const [printerData, setPrinterData] = useState([]);
//   const [editRow, setEditRow] = useState(null); // track which row is being edited
//   const [rfidValue, setRfidValue] = useState("");

//   const data = [
//     {
//       id: 1,
//       filterId: "FILT-001",
//       description: "Pre-filter AHU-01",
//       rfidTagId: null,
//     },
//     {
//       id: 2,
//       filterId: "FILT-002",
//       description: "Fine filter AHU-01",
//       rfidTagId: "RF12345",
//     },
//   ];

//   const handleSubmit = (record) => {
//     console.log("Saving RFID:", rfidValue, "for:", record);

//     setEditRow(null);
//     setRfidValue("");
//   };

//   const columns = [
//     {
//       title: "Filter ID",
//       dataIndex: "filterId",
//       key: "filterId",
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//     },
//     {
//       title: "RFID Tag ID",
//       dataIndex: "rfidTagId",
//       key: "rfidTagId",
//       render: (text) => {
//         return text ? (
//           <span>{text}</span>
//         ) : (
//           <span className="badge bg-warning text-dark text-light text-bold">
//             Not Assigned
//           </span>
//         );
//       },
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => {
//         const isEditing = editRow === record.id;

//         if (isEditing) {
//           return (
//             <div style={{ display: "flex", gap: 6 }}>
//               <Input
//                 placeholder="Scan / Enter RFID"
//                 value={rfidValue}
//                 onChange={(e) => setRfidValue(e.target.value)}
//                 style={{ width: 230 }}
//               />
//               <Button type="primary" onClick={() => handleSubmit(record)}>
//                 Submit
//               </Button>
//               <Button onClick={() => setEditRow(null)}>Cancel</Button>
//             </div>
//           );
//         }

//         return (
//           <Button onClick={() => setEditRow(record.id)}>
//             {record.rfidTagId ? "Change RFID" : "Assign RFID"}
//           </Button>
//         );
//       },
//     },
//   ];

//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content">
//           <div className="page-header">
//             <div className="page-title">
//               <nav aria-label="breadcrumb">
//                 <ol className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/assetmgt/dashboard">
//                       <i className="fas fa-home fa-lg" />
//                     </Link>
//                   </li>
//                   <h4 className="breadcrumb-item " aria-current="page">
//                     RFID List
//                   </h4>
//                 </ol>
//               </nav>
//               <h6>Manage Printers</h6>
//             </div>
//           </div>
//           <div className="card table-list-card">
//             <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
//               <div className="search-set mt-4"></div>
//               <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
//             </div>
//             <div className="card-body">
//               <div className="table-responsive">
//                 {/* {loading ? (
//                   <div className="text-center my-4">
//                     <Spin size="large" />
//                     <p>Loading data...</p>
//                   </div>
//                 ) : printerData?.length > 0 ? (
//                   <Table
//                     columns={columns}
//                     dataSource={printerData}
//                     rowKey="id"
//                   />
//                 ) : (
//                   <p className="text-center my-4">No data available</p>
//                 )} */}

//                 <Table columns={columns} dataSource={data} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default RfidAssign;

import React, { useEffect, useState } from "react";
// import Table from "../../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Button, Table, Input, Pagination, Spin } from "antd";
const { Search } = Input;

const RfidAssign = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");

  const fetchFilters = async (pageNumber = 1, limit = 50) => {
    setLoading(true);
    try {
      const url = `http://192.168.1.101:8080/api/getFiltersListPg?BlockId=0&Status=0&Barcode=0&pageNumber=${pageNumber}&recordslimit=${limit}`;
      const res = await fetch(url);
      const json = await res.json();

      const list = json?.ResultData || [];
      setData(list);

      if (list.length > 0) {
        setTotal(list[0].TotalCount);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilters(page, pageSize, searchText);
  }, [page, pageSize]);

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => (page - 1) * pageSize + index + 1,
    },

    {
      title: "Filter ID",
      dataIndex: "Lable",
    },

    {
      title: "AHU Code",
      dataIndex: "AHUcode",
    },

    {
      title: "RFID Tag ID",
      dataIndex: "Rfid",
      key: "Rfid",
      render: (text) => {
        return text ? (
          <span>{text}</span>
        ) : (
          <span className="badge bg-warning text-dark text-light text-bold">
            Not Assigned
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const isEditing = editRow === record.id;

        if (isEditing) {
          return (
            <div style={{ display: "flex", gap: 6 }}>
              <Input
                placeholder="Scan / Enter RFID"
                value={rfidValue}
                onChange={(e) => setRfidValue(e.target.value)}
                style={{ width: 230 }}
              />
              <Button type="primary" onClick={() => handleSubmit(record)}>
                Submit
              </Button>
              <Button onClick={() => setEditRow(null)}>Cancel</Button>
            </div>
          );
        }

        return (
          <Button onClick={() => setEditRow(record.id)}>
            {record.rfidTagId ? "Change RFID" : "Assign RFID"}
          </Button>
        );
      },
    },
  ];
  const [editRow, setEditRow] = useState(null); // track which row is being edited
  const [rfidValue, setRfidValue] = useState("");

  const handleSubmit = (record) => {
    console.log("Saving RFID:", rfidValue, "for:", record);

    setEditRow(null);
    setRfidValue("");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    RFID List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Printers</h6>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              {/* <div className="search-set mt-4"></div> */}
              <Search
                placeholder="Search by Barcode"
                allowClear
                style={{ width: 300, marginBottom: 16 }}
                onSearch={(value) => {
                  setPage(1);
                  setSearchText(value);
                  fetchFilters(1, pageSize, value);
                }}
              />
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {/* {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : printerData?.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={printerData}
                    rowKey="id"
                  />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )} */}
                <Spin spinning={loading}>
                  <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="Id"
                    pagination={false}
                  />
                </Spin>
                <Pagination
                  style={{ marginTop: 16, textAlign: "right" }}
                  current={page}
                  pageSize={pageSize}
                  total={total}
                  showSizeChanger
                  onChange={(p, ps) => {
                    setPage(p);
                    setPageSize(ps);
                  }}
                />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RfidAssign;
